<template>
  <div class="LadderSchemeItem" :class="{amountError: amountError || monthError}">
    <span>{{`阶梯区间${index + 1}:`}}</span>
    <el-input
      v-interage="true"
      :disabled="true"
      v-model="ladderItem.startMonth"
      class="input"
    ></el-input>
    月 ～
    <el-form-item :error="monthError">
      <el-input
        v-interage="true"
        :disabled="index + 1 !== length || configDisabled || endMonthDisabled"
        v-model="ladderItem.endMonth"
        @input="rules"
        class="input"
      ></el-input>
    </el-form-item>
    月,{{`每${amountType === 1? '期': '日'}租金`}}
    <el-form-item :error="amountError">
      <el-input
        v-limit-money="true"
        v-model="ladderItem.amount"
        :disabled="configDisabled"
        @input="amountChange"
        placeholder="请输入金额"
        class="amount"
      ></el-input>元
    </el-form-item>
    <i class="el-icon-delete" v-if="index + 1 === length && index !== 0 && !configDisabled" @click="deleteItem"></i>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
    amountType: {
      type: Number,
      default: 1,
    },
    length: {
      type: Number,
      default: 0,
    },
    maxDate: {
      type: Number,
      default: 0,
    },
    configDisabled: {
      type: Boolean,
      default: false,
    },
    endMonthDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      amountError: '',
      monthError: '',
      ladderItem: '',
    }
  },
  created() {
    this.ladderItem = this.item
  },
  methods: {
    amountChange() {
      if (!this.item.amount) {
        this.amountError = '请输入租金金额'
      } else {
        this.amountError = ''
      }
    },
    deleteItem() {
      this.$emit('deleteLadderItem', this.index)
    },
    rules() {
      if (!this.item.endMonth) {
        this.monthError = '请输入阶梯区间'
        return
      }
      if (this.maxDate < this.item.endMonth) {
        this.monthError = `可配置的阶梯区间最大值为${this.maxDate}月`
        return
      }
      if (this.item.endMonth !== '' && Number(this.item.endMonth) < Number(this.item.startMonth)) {
        this.monthError = '截止月数不能小于起始月数'
        return
      }
      this.monthError = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.LadderSchemeItem {
  display: flex;
  align-items: center;
  margin-top: 6px;

  ::v-deep .el-form-item__error {
    white-space: nowrap;
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }

  .el-icon-delete {
    margin-left: 10px;
  }

  .input {
    width: 100px;
  }

  .amount {
    width: 100px;
  }
}

.amountError {
  margin-bottom: 20px;
}
</style>
